import { Slider } from './Slider'

export const Component = { Slider }
